import React from 'react';
import moment from 'moment';
import '../css/dataTables.css';
import { CURRENCY, FORMAT_NUMBER } from '../libs/utils/Const';
const typeDocTex = (ObjType) => {
    let text = ''
    switch (ObjType) {
        case '17':
            text = 'Orden Venta'
            break;
        case '15':
            text = 'Entrega'
            break;
        case '17':
            text = 'Factura'
            break;


        default:
            break;
    }
    return text
}
const renderTableBody = (headers, data, action, checkbox, flagInvoices) => {

    let body = "";
    body = data.map((register, index) => {

        let fecha = new Date(register.DocDate);
        fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
        fecha = moment(fecha).format('DD-MM-YYYY');

        return (
            <tr key={index}>
                <td style={{ textAlign: "center", width: 50 }} onClick={() => checkbox.selectOne(index)}>
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} disabled={register.selected || false} />
                </td>
                <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{register?.DocNum || ""}</td>
                <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{register?.U_FMB_AttentionTypeName || ""}</td>
                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '200px', maxWidth: '200px', minWidth: '200px' }}>{register?.CardName || ""}</td>
                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '200px', maxWidth: '200px', minWidth: '200px' }}>{register?.ShipToCode || ""}</td>
                <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{fecha || ""}</td>
                {/* <td style={{ textAlign: "center" }}>{typeDocTex(register?.ObjType ?? '')}</td> */}
                {/* <td>{CURRENCY + FORMAT_NUMBER.new(register.DocTotal)}</td> */}
                {/* <td>{register.NumAtCard || ""}</td> */}
                {/* <td style={{ textAlign: "center" }}>{register.daysLast || 0}</td> */}
                {/* <td style={{ textAlign: "right" }}>{CURRENCY + FORMAT_NUMBER.new(register.totalPago) || ""}</td> */}

            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, checkbox, flagInvoices) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">
                {flagInvoices && <input type="checkbox" style={{ minWidth: '100%' }}
                    onChange={(event) => checkbox.selectAll(event.target.checked)} />}
            </td>
            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }} className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }} className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }} className="sticky-header table-header-yellow ">{headers[2].title}</td>
            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }} className="sticky-header table-header-yellow ">{headers[3].title}</td>
            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }} className="sticky-header table-header-yellow ">{headers[4].title}</td>
            {/* <td className="sticky-header table-header-yellow ">{headers[5].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[6].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[7].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[8].title}</td> */}
        </tr>;
    }

    body = renderTableBody(headers, data, action, checkbox, flagInvoices);
    let table = "";
    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar" style={{
            width: '100%',
            maxWidth: '100%',
            overflowX: 'auto',
            maxHeight: '400px',
            overflowY: 'auto'
        }}>
            <table id="dataTableCreate" className="display" style={{
                width: '100%',
                maxWidth: '100%',
                tableLayout: 'auto'
            }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderPendingDeliveries = (headers, data, action, checkbox, flagInvoices) => {
    return renderTable(headers, data, action, checkbox, flagInvoices);
}
